import React, { createContext, useContext } from 'react';
import { useLayoutMode } from 'app/components/ads/useLayoutMode';
import { LayoutMode } from 'app/styles/LayoutMode';
const LayoutContext = /*#__PURE__*/createContext(LayoutMode.Mobile);
export const LayoutProvider = _ref => {
  let {
    children
  } = _ref;
  const mode = useLayoutMode();
  return /*#__PURE__*/React.createElement(LayoutContext.Provider, {
    value: mode,
    "data-sentry-element": "unknown",
    "data-sentry-component": "LayoutProvider",
    "data-sentry-source-file": "LayoutContext.tsx"
  }, children);
};
export const useLayout = () => useContext(LayoutContext);